export const uk = {
  "NAVIGATION": {
    "HOME": "Головна",
    "PORTFOLIO": "Портфель",
    "PROFILE": "Профіль"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "Пошук у доступних угодах",
      "TITLE": "Пошук тільки в розділі доступних угод"
    },
    "QUICK_FILTERS": {
      "TITLE": "Швидкі фільтри",
      "CAPTION": "Оберіть категорію",
      "DEFI": "DeFi",
      "STAKING": "Стейкінг",
      "FARMING": "Фармінг",
      "LENDING": "Лендінг",
      "MINING": "Майнінг",
      "TRADING": "Трейдінг",
      "ALL": "Всі",
      "STABLECOINS": "Стейблкоіни",
      "DEPOSITS": "Депозити",
      "DEXES": "DEX біржі"
    },
    "PREMIUM_DEALS": {
      "TITLE": "Преміум угоди",
      "CAPTION": "Найкращі угоди тижня",
      "NO_DEALS": "Немає угод",
      "NO_DEALS_AVAILABLE": "Немає доступних угод",
      "GET_PREMIUM": "Отримати Преміум",
      "APY": "Річний відсоток",
      "NETWORK": "Мережа",
      "TOKEN_TYPE": "Тип токену"
    },
    "FILTERS": {
      "TITLE": "Фільтри",
      "FILTERS": "Фільтри",
      "SELECT_FILTERS": "Оберіть фільтри",
      "APPLY": "Застосувати"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "Доступні угоди",
      "CAPTION": "Нові ринкові можливості",
      "NO_DEALS": "Можливості не знайдено"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "Статус підписки",
      "CAPTION": "Деталі вашого преміум-членства",
      "ACTIVE": "АКТИВНА",
      "INACTIVE": "НЕАКТИВНА",
      "PERIOD": "Період",
      "EXPIRES": "Закінчується",
      "PROGRESS": "Прогрес підписки",
      "NOT_STARTED": "Не розпочато"
    },
    "REFERRAL": {
      "TITLE": "Реферальна програма",
      "CAPTION": "Запрошуйте друзів та заробляйте поінти",
      "RANK": "РАНГ",
      "TOTAL_REFERRALS": "Всього рефералів",
      "ACTIVE_REFERRALS": "Активні реферали",
      "REFERRALS_BY_LEVEL": "Реферали за рівнями",
      "COPY": "Копіювати",
      "POINTS_TO_NEXT_RANK": "{{points}} поінтів до наступного рангу"
    },
    "PREMIUM": {
      "TITLE": "Преміум підписка",
      "CAPTION": "Оберіть план та отримайте доступ до преміум-функцій",
      "MONTHS": "місяців",
      "BEST_VALUE": "Найкраща ціна",
      "PAYMENT_METHOD": "Спосіб оплати",
      "TELEGRAM_STARS": "Telegram Stars",
      "CRYPTO": "Криптовалюта",
      "YOU_SAVE": "Ви економите",
      "PROCESSING": "Обробка...",
      "PAY_STARS": "Оплатити {{amount}} Stars",
      "PAY_CRYPTO": "Оплатити ${{amount}} в криптовалюті",
      "PAYMENT_SUCCESS": {
        "TITLE": "Оплата успішна",
        "MESSAGE": "Вашу підписку успішно активовано!"
      },
      "PAYMENT_ERROR": {
        "TITLE": "Помилка оплати",
        "MESSAGE": "Не вдалося обробити платіж. Будь ласка, спробуйте ще раз.",
        "STARS_INSUFFICIENT": "Недостатньо зірок для оплати. Будь ласка, поповніть баланс зірок через @PremiumBot."
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "Платіж скасовано",
        "MESSAGE": "Ви скасували платіж. Спробуйте знову, коли будете готові."
      },
      "PAYMENT_PENDING": {
        "TITLE": "Обробка платежу",
        "MESSAGE": "Ваш платіж обробляється. Будь ласка, зачекайте."
      },
      "BUTTONS": {
        "OK": "OK",
        "CANCEL": "Скасувати",
        "BUY_STARS": "Купити Stars"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "Ранній доступ до Преміум угод з високим APY",
      "EXCLUSIVE_DEFI": "Ексклюзивні DeFi можливості з APY до 80%",
      "NOTIFICATIONS": "Сповіщення про нові Преміум угоди в реальному часі",
      "GUIDES": "Детальні покрокові інструкції та стратегії",
      "INSIGHTS": "Щотижневі ринкові огляди та рекомендації"
    },
    "FOOTER": {
      "CONTACT": "Якщо у вас є питання, зв'яжіться з нами:",
      "EMAIL_COPIED": "Email адреса скопійована в буфер обміну",
      "SUPPORT_TITLE": "Підтримка",
      "SUPPORT_CAPTION": "Зв'яжіться з нами, якщо у вас є питання",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram"
    },
    "LANGUAGE": {
      "TITLE": "Налаштування мови",
      "CAPTION": "Оберіть бажану мову",
      "LANGUAGES": {
        "EN": "Англійська",
        "RU": "Російська",
        "UK": "Українська",
        "ES": "Іспанська",
        "AR": "Арабська",
        "ZH": "Китайська"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "Стратегія портфеля",
    "SUBTITLE": "Огляд доступних стратегій портфеля",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "Збереження капіталу",
        "DESCRIPTION": "Низькоризикова стратегія, орієнтована на збереження капіталу через стейблкоіни зі стабільною дохідністю",
        "RISK_LEVEL": "Низький ризик"
      },
      "MODERATE": {
        "NAME": "Грошовий потік",
        "DESCRIPTION": "Низькоризикова стратегія, орієнтована на стабільний дохід через стейблкоіни та великі криптовалюти",
        "RISK_LEVEL": "Низький ризик"
      },
      "BALANCED": {
        "NAME": "Збалансований",
        "DESCRIPTION": "Помірно-ризикова збалансована стратегія, що включає стейблкоіни, великі криптовалюти та відібрані альткоіни",
        "RISK_LEVEL": "Помірний ризик"
      },
      "AGGRESSIVE": {
        "NAME": "Зростання",
        "DESCRIPTION": "Високоризикова стратегія зростання, орієнтована на великі криптовалюти та перспективні альткоіни",
        "RISK_LEVEL": "Високий ризик"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "Стейблкоіни",
      "BLUE_CHIPS": "Великі монети",
      "TOP_ALTCOINS": "Топ альткоіни",
      "OTHER_ALTCOINS": "Інші альткоіни",
      "INDICES": "Індекси"
    },
    "DETAILS": {
      "ASSETS": "Активи",
      "YIELD_STRATEGY": "Стратегія дохідності",
      "APY_PROJECTION": "Прогноз APY"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "Назад",
    "PROJECT_NOT_FOUND": "Проект не знайдено",
    "SETUP_STEPS": "Кроки налаштування",
    "GO_TO_PROJECT": "Перейти до проекту",
    "STATS": {
      "APY": "Річний відсоток"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "Підготовка Web3 гаманця",
        "DESCRIPTION": "Встановіть та налаштуйте Web3 гаманець, що підтримує обрану мережу. Наприклад, встановіть MetaMask для мереж на базі Ethereum, Phantom для Solana або Sui Wallet для мережі Sui. Переконайтеся, що ваш гаманець правильно налаштований та захищений."
      },
      "CONNECT_NETWORK": {
        "TITLE": "Підключення до мережі",
        "DESCRIPTION": "Додайте та підключіться до потрібної блокчейн-мережі у вашому гаманці. Якщо мережа не додана автоматично, вам може знадобитися додати її вручну, використовуючи RPC URL мережі, Chain ID та інші параметри мережі. Переконайтеся, що ви підключені до правильної мережі перед продовженням."
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "Перевірка балансу для комісій",
        "DESCRIPTION": "Переконайтеся, що у вас достатньо нативних токенів у гаманці для оплати комісій за транзакції (gas). Для мереж Ethereum потрібен ETH, для Solana - SOL, для Sui - SUI. Точна необхідна сума залежатиме від завантаженості мережі та складності транзакції."
      },
      "PREPARE_ASSETS": {
        "TITLE": "Підготовка активів",
        "DESCRIPTION": "Переведіть або придбайте конкретні токени, які ви хочете інвестувати (наприклад, USDC, USDT або DAI) на ваш підключений гаманець. Переконайтеся, що токени знаходяться у правильній мережі - деякі токени існують у кількох мережах, але не можуть бути безпосередньо переведені між ними."
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "Упс! Щось пішло не так",
    "DEFAULT_MESSAGE": "Сталася помилка. Будь ласка, спробуйте пізніше.",
    "RETRY_BUTTON": "Спробувати знову",
    "SPECIFIC_ERRORS": {
      "DOCKER": "Сервіс тимчасово недоступний. Будь ласка, спробуйте через кілька хвилин.",
      "NETWORK": "Проблема з підключенням до мережі. Перевірте ваше інтернет-з'єднання.",
      "SERVICE": "Сервіс тимчасово недоступний. Наші фахівці вже працюють над вирішенням.",
      "DATABASE": "Проблема з доступом до даних. Будь ласка, спробуйте пізніше."
    }
  }
}; 